import ApiClient from "../helpers/ApiClient";

export const getWelcomeData = async () => {
    try {
        const response = await ApiClient.get(`/homePage/homePage/getWelcomeSection`);
        // console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}




export async function updateWelcomeData({ id, welcome_message, graduates, faculty_members, employability_rate, years_of_excellence }) {
    try {

        const response = await ApiClient.put(`/homePage/homePage/updateWelcomeSectionManagement/${id}`,
            {
                welcome_message,
                graduates,
                faculty_members,
                employability_rate,
                years_of_excellence,
            },
        );
        console.log("response for edit....", response);
        return response;
    } catch (error) {
        console.error("Error updating Welcome Data:", error);
        throw error;
    }
}




